import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NavDataService } from 'src/app/modules/workshop/services/nav-data.service';
import { BatonFeature } from 'src/app/models/baton-features';
import { JoyrideService } from 'ngx-joyride';
import { AppConstants } from 'src/app/utilities/app-constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent implements OnInit {
  uniqueId;
  navMenuList;
  showSection = true;

  featureItems = [
    {
      id: 1,
      name: 'Teams',
      description: 'Manage teams here. You can create a new Team, View all the Teams and Edit or Delete exisiting Teams.',
      enabled: true,
      canCreate: true
    },
    {
      id: 2,
      name: 'Projects',
      description: 'Manage projects here. You can create a new Project, View all the Projects and Edit or Delete exisiting Projects.',
      enabled: true,
      canCreate: true
    },
    {
      id: 3,
      name: 'Assessments',
      description: `Manage Assessments here. You can create a new Assessment,
        View all the Assessments and Edit or Delete exisiting Assessments.`,
      enabled: true,
      canCreate: true
    }, {
      id: 4,
      name: 'Workshops',
      description: `Manage Workshops here. You can create a new Workshop,
      View all the Workshops and Edit or Delete exisiting Workshops. Workshops will contain activities.`,
      enabled: true,
      canCreate: false
    }, {
      id: 5,
      name: 'Metrics',
      description: 'Manage Metrics here. You can View all the Metrics',
      enabled: true,
      canCreate: false
    }
  ];

  colors = ['#273c75', '#3498db', '#9b59b6', '#6c5ce7', '#718093', '#9B59B6', '#B33771'];

  constructor(
    private navDataService: NavDataService,
    private readonly joyrideService: JoyrideService,
    private router: Router,

  ) { }

  ngOnInit() {

    this.showSection = localStorage.getItem(AppConstants.LS_SHOW_HELP_SECTION_HOME) === '0' ? false : true;

    this.navDataService.load();
    this.navDataService.navData.subscribe(
      (suc: BatonFeature[]) => {
        this.navMenuList = [];

        if (!suc || !suc.length) {
          return;
        }

        suc.forEach((navMenuItem, index) => {
          navMenuItem['color'] = this.colors[index];
          this.navMenuList.push(navMenuItem);
          // const obj = this.buildNavList(navItem);
          // this.fillerNav.push(obj);
        });
        // this.defaultRoute = localStorage.getItem(AppConstants.PARAM_LOCAL_STORAGE_DEFAULT_ROUTE);
      }, err => { }
    );

    // this.joyrideService.startTour(
    //   this.showSection ? { steps: ['firstStep', 'secondStep', 'thirdStep', 'teamsListStep@teams', 'teamCreateBtnStep@teams'] } :
    //     { steps: ['firstStep', 'teamsListStep@teams', 'teamCreateBtnStep@teams'] }
    // );

  }

  hideHelpSection() {
    localStorage.setItem(AppConstants.LS_SHOW_HELP_SECTION_HOME, '0');
    this.showSection = false;
  }

  goToFeature(item) {

    switch (item.FEATURE_NAME || item.name) {
      case 'Teams':
        this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_ADD_TEAM}`]);
        break;
      case 'Assessments':
        this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_ASSESSMENTS}`]);
        break;
      case 'Projects':
        this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_ADD_PROJECTS}`]);
        break;
      case 'Workshops':
        this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_WORKSHOPS}`]);
        break;
      case 'Metrics':
        this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_METRICS}`]);
        break;
      default:
        break;
    }
  }

}
